import {
  Flex,
  Loading,
} from "@components/index";
import withShow from "@common/withShow";

const LoadingFragment: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ style }) => (
  <Flex block alignItems="center" justifyContent="center" style={style}>
    <Loading size="sm" />
  </Flex>
);

export default withShow(LoadingFragment);